import React from 'react';
import PropTypes from 'prop-types';
import Experiment, { When } from '@carvana/experiment';

import PromotionModal from './PromotionModal';
import Cookie from '../../../services/Cookie';
import { closeModal } from '../../../utilities/bannersAndModals';
import { GLOBAL_EXPERIMENT_CONFIG } from '../../../constants';


const PromotionModalBehindExperiment = props => {
  const {
    experiment: {
      name,
      identifierKey,
      config,
      bucket,
    },
    environment,
    userId,
    cookieName,
    handleCloseModal,
  } = props;
  const shouldUseUserId = identifierKey === 'userId' && userId;
  const identifier = shouldUseUserId ? userId : Cookie.getCookie('BrowserCookieId');

  return (
    <Experiment
      name={name}
      identifier={identifier}
      environment={environment}
      config={{
        ...config,
        defaultBucket: 'not-desired-bucket',
      }}
      {...GLOBAL_EXPERIMENT_CONFIG}
      {...config}
    >
      <When bucket={bucket}>
        <PromotionModal {...props} />
      </When>
      <When bucket="not-desired-bucket">
        <div>
          {() => closeModal(cookieName, handleCloseModal, true)}
        </div>
      </When>
    </Experiment>
  );
};

PromotionModalBehindExperiment.propTypes = {
  experiment: PropTypes.shape({
    name: PropTypes.string.isRequired,
    identifierKey: PropTypes.string.isRequired,
    config: PropTypes.shape({}),
    bucket: PropTypes.string.isRequired,
  }).isRequired,
  environment: PropTypes.string.isRequired,
  userId: PropTypes.string,
  cookieName: PropTypes.string.isRequired,
  handleCloseModal: PropTypes.func,
};

PromotionModalBehindExperiment.defaultProps = {
  userId: '',
  handleCloseModal: () => {},
};

export default PromotionModalBehindExperiment;
